/* Re-export the engine's data constants for the UI (dropdowns, labels, maps).
 * The browser never runs the engine — these are just the shared reference data
 * (§1: reuse, don't duplicate). */
import {
  COUNTRIES, SUPPLIERS, COMPONENTS, SEGMENTS, STRATEGIES, BRAND_STRATS,
  AD_CHANNELS, CREATIVES, TECH_TREE, TECH_BY_ID, METHODS, CITIES,
  COMPETITORS, LESSONS, QUIZ,
} from '@venturewrist/engine';

export {
  COUNTRIES, SUPPLIERS, COMPONENTS, SEGMENTS, STRATEGIES, BRAND_STRATS,
  AD_CHANNELS, CREATIVES, TECH_TREE, TECH_BY_ID, METHODS, CITIES,
  COMPETITORS, LESSONS, QUIZ,
};

export interface Named { id: string; name: string; [k: string]: unknown }

const index = (arr: Named[]) => Object.fromEntries(arr.map((x) => [x.id, x]));

export const COUNTRY_BY_ID = index(COUNTRIES as Named[]);
export const SEGMENT_BY_ID = index(SEGMENTS as Named[]);
export const STRATEGY_BY_ID = index(STRATEGIES as Named[]);
export const CHANNEL_BY_ID = index(AD_CHANNELS as Named[]);
export const CREATIVE_BY_ID = index(CREATIVES as Named[]);

export const SUPPLIER_CATS = ['chips', 'display', 'battery', 'sensors', 'assembly'] as const;
export type SupplierCat = (typeof SUPPLIER_CATS)[number];

export const supplierName = (cat: SupplierCat, id: string | undefined): string => {
  if (!id) return '—';
  const list = (SUPPLIERS as Record<string, Named[]>)[cat] || [];
  return list.find((s) => s.id === id)?.name ?? id;
};

/** Distribution methods a player can buy into a country (online is the default). */
export const DIST_METHODS = (METHODS as Named[]).filter((m) =>
  ['dist', 'carrier', 'stores'].includes(m.id),
);

// ── Manufacturing cities (engine `cityById`/`factoryCities` are module-local) ──
export interface City { id: string; city: string; country: string; cc?: string; factoryFit: number; whFit: number; laborIdx: number; buildIdx: number; note: string; lat: number; lon: number; [k: string]: unknown }
export const cityById = (id: string): City | undefined => (CITIES as City[]).find((c) => c.id === id);
/** Factory-builder city list — only buildable cities, best manufacturing fit first. */
export const factoryCities = (): City[] =>
  (CITIES as City[]).filter((c) => c.factoryFit > 0).slice().sort((a, b) => b.factoryFit - a.factoryFit);
